export const UserMenuStyles = {
  elevation: 0,
  sx: {
    overflow: 'visible',
    borderRadius: '8px',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.22))',
    mt: 1.5,
    '& .MuiAvatar-root': {
      width: 26,
      height: 26,
      ml: -0.5,
      mr: 1.5,
    },
  },
};
